import React from "react";
import { prizes } from "../../data/program";
import { SectionHeading } from "./SectionHeading";
export function PrizesSection() {
  const [first, second, third, ...rest] = prizes;
  return <section id="prizes" className="scroll-mt-20 bg-tomato py-24 text-ink md:py-32" data-id="element-580" data-mp="un4yg6kune45">
      <div className="mx-auto max-w-[1400px] px-5 md:px-8" data-id="element-581" data-mp="potmnqazutja">
        <SectionHeading title="Prizes" intro="Scored live by AI against the published criteria, confirmed by the investor panel on Demo Day." data-id="element-582" data-mp="pqeidj91oiiq" />

        <div className="mt-16 grid gap-4 md:mt-20 lg:grid-cols-[1.5fr_1fr]" data-id="element-583" data-mp="1iead4if200cv">
          <div className="flex flex-col justify-between rounded-[28px] bg-sun p-8 md:p-10" data-id="element-584" data-mp="1dlza36p0nyg3">
            <p className="text-[13px] font-bold uppercase tracking-wide" data-id="element-585" data-mp="18nxu4umw0f8u">{first.label}</p>
            <p className="mt-10 font-display text-[clamp(6rem,16vw,13rem)] leading-[0.85]" data-id="element-586" data-mp="262jt33pl5tw3">{first.amount}</p>
          </div>
          <div className="grid gap-4" data-id="element-587" data-mp="21btlrkxlngyr">
            {[second, third].map(p => <div key={p.place} className="flex items-end justify-between gap-4 rounded-[28px] bg-cream p-8" data-id="element-588" data-mp="s070yepkxosj">
                <p className="text-[13px] font-bold uppercase tracking-wide" data-id="element-589" data-mp="x01t0ll3ckf6">{p.label}</p>
                <p className="font-display text-7xl leading-none md:text-8xl" data-id="element-590" data-mp="j8x1k6rvmyfx">{p.amount}</p>
              </div>)}
          </div>
        </div>

        <div className="mt-4 grid gap-4 sm:grid-cols-2" data-id="element-591" data-mp="n7w11buua2zz">
          {rest.map(p => <div key={p.place} className="flex items-center justify-between gap-4 rounded-[28px] border-2 border-ink px-8 py-6" data-id="element-592" data-mp="98wce47bto3t">
              <p className="text-[13px] font-bold uppercase tracking-wide" data-id="element-593" data-mp="9j1d73k0rgz">{p.label}</p>
              <p className="font-display text-3xl uppercase" data-id="element-594" data-mp="bvsoav7ce6p">To be announced</p>
            </div>)}
        </div>
      </div>
    </section>;
}